import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Thumbnail } from './components/Thumbnail';
import { Badges } from './components/Badges';
import { BadgesFromFlags } from './components/BadgesFromFlags';
import { Name } from './components/Name';
import { Metadata } from './components/Metadata';
import { Pricing } from './components/Pricing';
import { BottomTag } from './components/BottomTag';
import { CustomInfo } from './components/CustomInfo';
import { HotelTileSkeleton, HotelTileSkeletonList } from './HotelTile.skeleton';
import { TILE_BORDER_RADIUS } from './HotelTile.constants';
import type { HotelTileRootProps } from './HotelTile.types';

interface HotelTileComponent
  extends React.FC<HotelTileRootProps>,
    Readonly<{
      Thumbnail: typeof Thumbnail;
      Badges: typeof Badges;
      BadgesFromFlags: typeof BadgesFromFlags;
      Name: typeof Name;
      Metadata: typeof Metadata;
      Pricing: typeof Pricing;
      BottomTag: typeof BottomTag;
      CustomInfo: typeof CustomInfo;
      Skeleton: typeof HotelTileSkeleton;
      SkeletonList: typeof HotelTileSkeletonList;
    }> {}

const HotelTileRoot: React.FC<HotelTileRootProps> = ({ children, containerWidth, ...flexProps }) => (
  <Flex
    role="group"
    cursor="pointer"
    alignItems="center"
    gap={3}
    width={containerWidth ? pxToRem(containerWidth) : '100%'}
    position="relative"
    borderRadius={pxToRem(TILE_BORDER_RADIUS)}
    {...flexProps}
  >
    {children}
  </Flex>
);

export const HotelTile = Object.assign(React.memo(HotelTileRoot), {
  Thumbnail,
  Badges,
  BadgesFromFlags,
  Name,
  Metadata,
  Pricing,
  BottomTag,
  CustomInfo,
  Skeleton: HotelTileSkeleton,
  SkeletonList: HotelTileSkeletonList,
}) as HotelTileComponent;
